import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { WithParams } from '@utils/typescript';
import { snakes } from '@utils/lodash';

export type UpdateUserPasswordParams = WithParams<{
  password: string;
  password_confirmation: string;
  otp_code: string;
}>

export class UserPasswordApi {
  static update = async (params: UpdateUserPasswordParams) => {
    return await authAxios
      .put(`${API_V1_BASE}/user/password`, snakes(params));
  };
}
